import { convertEditorStateToString } from "../../textEditor.utils";
import { isEmpty, removeSpacesAndHTML } from "../../general.utils";
import i18next from "i18next";

export const validateHrLocalBenefitGroupCreate = ({
  name,
  categories,
  description,
  photo,
  capacity,
  summary
}) => {
  const errors = {};

  if (!name.trim()) {
    errors.name = i18next.t("required_field");
  } else if (removeSpacesAndHTML(name).length > 30) {
    errors.name = i18next.t("too_long");
  } else if (!removeSpacesAndHTML(name)) {
    errors.name = i18next.t("html_tag_ban");
  }

  if (isEmpty(categories)) {
    errors.categories = i18next.t("required_field");
  }

  const descriptionString = convertEditorStateToString(description);
  const tagRegex = /<.+?>/g;
  const formattedDescription = descriptionString.replace(tagRegex, "").trim();
  if (formattedDescription.length > 1001) {
    errors.description = i18next.t("too_long");
  }

  if (!summary.trim()) {
    errors.summary = i18next.t("required_field");
  } else if (removeSpacesAndHTML(summary).length < 20) {
    errors.summary = i18next.t("too_short");
  } else if (removeSpacesAndHTML(summary).length > 90) {
    errors.summary = i18next.t("too_long");
  } else if (!removeSpacesAndHTML(summary)) {
    errors.summary = i18next.t("html_tag_ban");
  }

  if (!photo) {
    errors.photo = i18next.t("required_field");
  }

  return errors;
};
export const validateHrLocalBenefitCreate = ({
  title,
  tokenPrice,
  expiration,
  description,
  summary,
  vouchers,
  quantity
}) => {
  const errors = {};

  if (!title.trim()) {
    errors.title = i18next.t("required_field");
  } else if (removeSpacesAndHTML(title).length > 30) {
    errors.title = i18next.t("too_long");
  } else if (!removeSpacesAndHTML(title)) {
    errors.title = i18next.t("html_tag_ban");
  }

  if (!expiration) {
    errors.expiration = i18next.t("required_field");
  }

  if (expiration !== "voucher") {
    if (tokenPrice === "" || tokenPrice === null || tokenPrice === undefined) {
      errors.tokenPrice = i18next.t("required_field");
    }
  }

  if (expiration === "voucher") {
    if (vouchers.length === 0) {
      errors.vouchers = i18next.t("add_voucher_please");
    } else {
      vouchers.forEach(voucher => {
        if (voucher.name === "" || voucher.price === "") {
          errors.vouchers = i18next.t("please_fill_all_fields");
        }
      });
    }
  }

  const descriptionString = convertEditorStateToString(description);
  const tagRegex = /<.+?>/g;
  const formattedDescription = descriptionString.replace(tagRegex, "").trim();
  if (formattedDescription.length > 1001) {
    errors.description = i18next.t("too_long");
  }

  if (!summary.trim()) {
    errors.summary = i18next.t("required_field");
  } else if (removeSpacesAndHTML(summary).length < 20) {
    errors.summary = i18next.t("too_short");
  } else if (removeSpacesAndHTML(summary).length > 90) {
    errors.summary = i18next.t("too_long");
  } else if (!removeSpacesAndHTML(summary)) {
    errors.summary = i18next.t("html_tag_ban");
  }

  if (!isEmpty(quantity) && quantity <= 0) {
    errors.quantity = i18next.t("min_quantity_requirement");
  }

  // if (!photo) {
  //   errors.photo = '* Required';
  // }

  return errors;
};
